import React from 'react';
import ReactDOM from 'react-dom';
// import App from './App';
import {Provider} from 'react-redux';
import {NoteStore} from './redux/NoteStore';
import MainApp from './MainApp';


ReactDOM.render(
  <React.StrictMode>
    <Provider store={NoteStore}>
      <MainApp />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

